/**
 * Atoms
 * 
 * These are the basic building blocks of the design system,
 * following the ATOMic design methodology.
 * 
 * They are the smallest functional units that can't be broken down further.
 */

// Layout Atoms
export { default as Box } from './Box';
export { default as AutoScrollBox } from './AutoScrollBox';
export { default as ScrollableBox } from './ScrollableBox';

// Typography Atoms
export { default as Typography } from './Typography';

// Input Atoms
export { default as Button } from './Button';
export { default as TextField } from './TextField';
export { default as EditableTextField } from './EditableTextField';

// Modal Atoms
export { default as ExplanationModal } from './ExplanationModal';
export { default as AddSectionModal } from './AddSectionModal';
export { default as AddDiagramModal } from './AddDiagramModal';

// Action Atoms
export { default as DesignActionButtons } from './DesignActionButtons';

// Composite Atoms
export { default as Accordion } from './Accordion';